const answer1 = `
  <div>
    <p>What defines a great digital experience for you as a customer? Is it the site’s responsiveness or how it is organized or how fast it helps you with the check out? It probably is the combination of all of it and more. Good UX Designers are intuitive and well-aware of the world around them in an effort to create an effortless, innovative, and simplistic experiences.</p>
    <br/>
    <p>Our User Experience Design Immersive course aims to push students to think like designers and arm them with the tills needed to implement their ideas.</p>
    <br/>
    <p>The evolution of digital has created opportunities for companies to create better digital experiences for their customers. To do that they are looking for teams of Experience Designers who can help them navigate through their customer journeys.</p>
  </div>
`

const answer2 = `
    <div>
        <p>By the end of our Experience Design Immersive course, you will be able to:</p>
        <ul>
            <li>Conduct end user research and develop techniques to understand their needs. Develop personas to understand different paths they might take.</li>
            <li>Techniques to organize information and calls to action for a site or app.</li>
            <li>Design digital products which make users want to not leave in the middle.</li>
            <li>Design a digital product that behaves intuitively and brings joys and function to users.</li>
            <li>User visual and interactive design in order to make intelligent digital products.</li>
            <li>Develop the ability to present your ideas through sketches, wireframes, presentations and video.</li>
            <li>Learn to work in agile mode, collaborate with product design and development teams to see products come to life.</li>
        </ul>
    </div>
`

const answer3 = `
    <div>
        <p>By the end of your EX Design Course, you will have:</p>
        <ul>
            <li>Your strong portfolio of user research, wireframes, customer journey maps and working prototypes </li>
            <li>Learn about UX techniques and strategies from the top UX practitioners currently in the field.</li>
            <li>Networked with some of the best designers, product managers and entrepreneurs in your local community</li>
        </ul>
    </div>
`

const faqs = {
    q1: {
      question: "Why Take This Course?",
      answer: answer1,
    },
    q2: {
      question: "What Skills Will I Leave With?",
      answer: answer2,
    },
    q3: {
      question: "What Will I Achieve?",
      answer: answer3
    },
    q4: {
      question: "Who's in My Class?",
      answer:
        "People who are passionate about the world of creating great experiences through great EX design. Well, they are the ones like you! From graphic designers, journalists, architects, software engineers, creative directors, college graduates and Marie Kondo (just kidding! But we do believe in the fact that in design less is sometimes more) — you’ll be surrounded by like-minded creatives looking to enter the Experience design world professionally."
    }
  };

export default faqs;